import { IconDashboard } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

import { AtlasAssistant, Chat, Tool } from '#plugin-chat';
import { views as viewsObject } from '#views.ts';

import type { EntityAgent } from '#schema/generated/graphql/graphql.ts';

const views = [...Object.values(viewsObject)];

import React from 'react';

import { useViewInstances } from '#core/hooks/fusion/useViewInstances.ts';

import classes from './index.module.css';
import { IpsoDomain } from '#instructions/IpsoDomain.tsx';
import { Instructions } from '#plugin-chat/lib/instructions/Instructions.tsx';

export const Route = createFileRoute('/dashboard/')({
  component: RouteComponent,
  staticData: {
    route: {
      icon: IconDashboard,
      sidebarPosition: 1,
      title: 'Placeholder Dashboard',
    },
  },
});

function RouteComponent() {
  return (
    <div className={classes.content}>
      {/* AiPSO Placeholder Dashboard */}
      <div className={classes.chat}>
        <Chat views={views}>
          <AtlasAssistant>
            <Tool.Plan />
            <Tool.DescribeViews views={views} />
            <Tool.QueryKnowledgeGraph />
            <Tool.TransformDataset />
            <Tool.AskUserQuestion />
            <Tool.ShowDashboard />

            <IpsoDomain />
            <EntityOverviewInstructions />
          </AtlasAssistant>
        </Chat>
      </div>
    </div>
  );
}

function EntityOverviewInstructions() {
  const { data: instances } = useViewInstances(viewsObject.EntityAgentView, {
    filter: [
      {
        in: {
          property: viewsObject.EntityAgentView?.property.entityType,
          values: [
            // 'location',
            // 'sector',
            // 'reservoir',
            'field',
          ],
        },
      },
    ],
    limit: 1000,
  });
  const instancesByType: Record<string, EntityAgent> = Object.groupBy(
    instances ?? [],
    (it: EntityAgent) => it?.entityType ?? 'unknown',
  );
  return (
    <Instructions priority={100}>
      {Object.entries(instancesByType).map(([entityType, instances]: [string, EntityAgent[]]) => (
        <React.Fragment key={entityType}>
          <h1>`{entityType}` Entities</h1>
          <dl>
            {instances?.map(({ space, externalId, name }: EntityAgent & { space: string; externalId: string }) => (
              <React.Fragment key={`${space}-${externalId}-${name}`}>
                <dt>{name}</dt>
                <dd>
                  {externalId} ({space})
                </dd>
              </React.Fragment>
            ))}
          </dl>
        </React.Fragment>
      ))}
    </Instructions>
  );
}
